export default __webpack_public_path__ + "alberta-filter-nursinghome.925a59d2938b939666ab.svg";